import React from 'react'

interface FileTableSkeletonProps {
  rowCount?: number
  showHeader?: boolean
}

export const FileTableSkeleton: React.FC<FileTableSkeletonProps> = ({
  rowCount = 8,
  showHeader = true,
}) => {
  const skeletonRows = Array.from({length: rowCount}, (_, index) => index)

  return (
    <div className='table-responsive ob-file-table'>
      <table
        className='table table-flush table-row-bordered align-middle gs-0'
        style={{
          borderRadius: 'var(--ob-file-table-border-radius)',
          border: `1px solid var(--ob-file-table-border-color)`,
          overflow: 'hidden',
        }}
      >
        {showHeader && (
          <thead>
            <tr
              style={{
                borderBottom: '2px solid var(--ob-file-table-header-border)',
                backgroundColor: 'var(--ob-file-table-header-bg)',
              }}
            >
              <th
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  fontWeight: 'var(--ob-font-weight-bold, 600)',
                  fontSize: 'var(--ob-file-table-font-size)',
                  color: 'var(--ob-gray-600)',
                  borderBottom: 'none',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '16px',
                    width: '60px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                />
              </th>
              <th
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  fontWeight: 'var(--ob-font-weight-bold, 600)',
                  fontSize: 'var(--ob-file-table-font-size)',
                  color: 'var(--ob-gray-600)',
                  borderBottom: 'none',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '16px',
                    width: '100px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                />
              </th>
              <th
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  fontWeight: 'var(--ob-font-weight-bold, 600)',
                  fontSize: 'var(--ob-file-table-font-size)',
                  color: 'var(--ob-gray-600)',
                  borderBottom: 'none',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '16px',
                    width: '50px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                />
              </th>
              <th
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  fontWeight: 'var(--ob-font-weight-bold, 600)',
                  fontSize: 'var(--ob-file-table-font-size)',
                  color: 'var(--ob-gray-600)',
                  borderBottom: 'none',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '16px',
                    width: '60px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                />
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {skeletonRows.map((index) => (
            <tr
              key={index}
              style={{
                borderBottom: '1px solid var(--ob-file-table-border-color)',
              }}
            >
              <td
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  verticalAlign: 'middle',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--ob-spacing-2)',
                  }}
                >
                  {/* File Icon Skeleton */}
                  <div
                    className='skeleton-icon'
                    style={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: 'var(--ob-gray-300)',
                      borderRadius: '3px',
                      animation: 'pulse 1.5s infinite',
                    }}
                  />
                  {/* File Name Skeleton */}
                  <div
                    className='skeleton-text'
                    style={{
                      height: '14px',
                      width: `${Math.random() * 100 + 80}px`,
                      backgroundColor: 'var(--ob-gray-300)',
                      borderRadius: '3px',
                      animation: 'pulse 1.5s infinite',
                    }}
                  />
                </div>
              </td>
              <td
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  verticalAlign: 'middle',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '14px',
                    width: '80px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '3px',
                    animation: 'pulse 1.5s infinite',
                  }}
                />
              </td>
              <td
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  verticalAlign: 'middle',
                  textAlign: 'right',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '14px',
                    width: '60px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '3px',
                    animation: 'pulse 1.5s infinite',
                    marginLeft: 'auto',
                  }}
                />
              </td>
              <td
                style={{
                  padding: 'var(--ob-file-table-cell-padding)',
                  verticalAlign: 'middle',
                  textAlign: 'center',
                }}
              >
                <div
                  className='skeleton-text'
                  style={{
                    height: '14px',
                    width: '20px',
                    backgroundColor: 'var(--ob-gray-300)',
                    borderRadius: '3px',
                    animation: 'pulse 1.5s infinite',
                    margin: '0 auto',
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
